// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-container[data-v-710f95cb]{height:50vh;overflow-y:auto}[data-v-710f95cb] .el-dialog__header{padding:0}[data-v-710f95cb] .el-dialog__body{padding:0;color:#000}", ""]);
// Exports
module.exports = exports;
